import * as React from "react"
import { ImageSeeker } from "@ui-seeker/core"
import { Box } from "@mui/material"


export default function PricingImageSkuBlock({ skuID }) {
	return <Box 
		sx={{ 
			display: 'flex', 
			justifyContent: 'center', 
			position: 'relative', 
			overflow: 'hidden', 
			width: 100, 
			height: 100, 
			border: '2px solid', 
			borderColor: "divider", 
			margin: "0 auto" 
		}}
	>
		<ImageSeeker
			src={`/api/master-data/sku/image/${skuID}`}
			sx={{ width: 'auto', height: 100 }} 
			containerProps={{ sx: { 'span': { display: 'block !important' } } }}
		/>
	</Box>
}